import { Link } from 'react-router-dom';

interface BrandLogoProps {
  variant?: 'full' | 'mark';
  /** `hero` — prominent full logo (e.g. login); `default` — compact header size */
  size?: 'default' | 'hero';
  className?: string;
  linkToHome?: boolean;
  onHomeClick?: () => void;
}

const FULL_SIZE_CLASS = {
  default: 'h-8 w-auto',
  hero: 'h-auto w-[min(200px,85vw)] sm:w-[220px]',
} as const;

const MARK_SIZE_CLASS = {
  default: 'h-8 w-8',
  hero: 'h-12 w-12 sm:h-14 sm:w-14',
} as const;

export default function BrandLogo({
  variant = 'full',
  size = 'default',
  className = '',
  linkToHome = false,
  onHomeClick,
}: BrandLogoProps) {
  const img =
    variant === 'mark' ? (
      <img
        src="/kromeka-o.png"
        alt="Kromeka"
        className={`${MARK_SIZE_CLASS[size]} object-contain ${className}`}
      />
    ) : (
      <img
        src="/kromeka-logo.png"
        alt="Kromeka"
        className={`${FULL_SIZE_CLASS[size]} object-contain ${className}`}
      />
    );

  if (linkToHome) {
    if (onHomeClick) {
      return (
        <button
          type="button"
          onClick={onHomeClick}
          className="shrink-0 transition opacity-90 hover:opacity-100"
          title="Return to project library"
        >
          {img}
        </button>
      );
    }
    return (
      <Link to="/" className="shrink-0 transition opacity-90 hover:opacity-100">
        {img}
      </Link>
    );
  }

  return img;
}
